module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("jf6JR"))).then(() => parcelRequire('hEqeo'));